import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { Box } from "../../../../../../Box/index.js";
import { Typography } from "../../../../../../Typography/index.js";
import { VideoFailed } from "../VideoFailed.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Player_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Player_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const Player = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { playing, pip, playbackRate, volume, activePlayer: PlayerComponent, onReady, onStart, onLoadStart, onPlay } = props;
    const [error, setError] = useState(false);
    const playerRef = useRef(null);
    const startOnPlayRef = useRef(true);
    useEffect(()=>{
        if (!playerRef.current) return;
        if (playerRef.current.paused && true === playing) playerRef.current.play();
        if (!playerRef.current.paused && false === playing) playerRef.current.pause();
        playerRef.current.playbackRate = null != playbackRate ? playbackRate : 1;
        playerRef.current.volume = null != volume ? volume : 1;
    }, [
        playing,
        playbackRate,
        volume
    ]);
    useEffect(()=>{
        if (!playerRef.current || !globalThis.document) return;
        if (pip && !document.pictureInPictureElement) try {
            var _playerRef_current_requestPictureInPicture, _playerRef_current;
            null == (_playerRef_current_requestPictureInPicture = (_playerRef_current = playerRef.current).requestPictureInPicture) || _playerRef_current_requestPictureInPicture.call(_playerRef_current);
        } catch (err) {}
        if (!pip && document.pictureInPictureElement) try {
            var _document_exitPictureInPicture, _document;
            null == (_document_exitPictureInPicture = (_document = document).exitPictureInPicture) || _document_exitPictureInPicture.call(_document);
        } catch (err_0) {}
    }, [
        pip
    ]);
    const handleLoadStart = (event)=>{
        startOnPlayRef.current = true;
        null == onReady || onReady();
        null == onLoadStart || onLoadStart(event);
    };
    const handlePlay = (event_0)=>{
        if (startOnPlayRef.current) {
            startOnPlayRef.current = false;
            null == onStart || onStart(event_0);
        }
        null == onPlay || onPlay(event_0);
    };
    const handleVideoError = ()=>{
        setError(()=>true);
    };
    const getPlayerRef = useCallback((node)=>{
        playerRef.current = node;
        if ('function' == typeof ref) ref(node);
        else if (null !== ref) ref.current = node;
    }, [
        ref
    ]);
    if (!PlayerComponent) return null;
    if (error) return /*#__PURE__*/ jsx(VideoFailed, {
        width: props.width,
        height: props.height
    });
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        gap: "12",
        children: [
            /*#__PURE__*/ jsx(PlayerComponent, _object_spread_props(_object_spread({}, props), {
                style: props.style,
                className: props.className,
                slot: props.slot,
                ref: getPlayerRef,
                src: props.src,
                crossOrigin: props.crossOrigin,
                preload: props.preload,
                controls: props.controls,
                muted: props.muted,
                autoPlay: props.autoPlay,
                loop: props.loop,
                playsInline: props.playsInline,
                config: props.config,
                onLoadStart: handleLoadStart,
                onPlay: handlePlay,
                onError: handleVideoError,
                children: props.children
            })),
            props.description && /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "text.light.tertirary",
                children: props.description
            })
        ]
    });
});
export { Player };
